module.exports = __webpack_public_path__ + "static/media/neva-map.4cededa6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/neva/neva-map.png
// module id = 347
// module chunks = 0